export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-ruler-line',
      title: 'Precise Measurements',
      description: 'Every garment is crafted using exact measurements taken by our expert consultants, ensuring a perfect fit every time.'
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'Premium Materials',
      description: 'We source only the finest fabrics from renowned mills worldwide, offering exceptional quality and durability.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Expert Craftsmanship',
      description: 'Our master tailors bring decades of experience, combining traditional techniques with modern precision.'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Convenient Service',
      description: 'Enjoy the luxury of house and office calls nationwide. We come to you with our complete collection.'
    },
    {
      icon: 'ri-time-line',
      title: 'Reliable Delivery',
      description: 'Consistent 6-8 week turnaround with quality checks at every stage to ensure perfection.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Personal Attention',
      description: 'Dedicated consultants guide you through every step, from fabric selection to final fitting.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Why Choose <span className="text-[#C9A961]">British Custom Tailors</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the difference of <strong>true custom tailoring</strong> with unmatched quality and service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 bg-[#C9A961]/10 rounded-full flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-3xl text-[#C9A961]`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a 
            href="#consultation" 
            className="inline-block bg-[#C9A961] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#B89851] transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            Start Your Custom Experience
          </a>
        </div>
      </div>
    </section>
  );
}